import {styled} from "@mui/material/styles";
import {Box, Typography} from "@mui/material";
import Image from '../../components/skeleton/ImageComponent';
import {Link} from "react-router";

export const BlogSectionPadding = styled('section')(() => ({
  paddingBottom: '3.7em'
}));

export const BlogContainer = styled(Box)(() => ({
  marginTop: '1.7em',
}));

export const BlogMainContainer = styled(Box)(() => ({
  maxWidth: '95em',
  margin: '0 auto',
  padding: '1em'
}));

export const BlogTitle = styled(Typography)(({theme}) => ({
  fontFamily: 'Inter',
  fontSize: '2.28em',
  marginTop: '.4em',
  color: theme.palette.secondary.main,
  textTransform: 'capitalize',
  fontWeight: '600'
}));

export const BlogSubtitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1em',
  color: 'rgba(0, 0, 0, 0.6)',
  fontWeight: '400',
  marginTop: '0.4em'
}));

export const BlogThumbnail = styled(Box)(() => ({
  marginTop: '0.8em',
  height: '43em',
  "@media (max-width: 768px)": {
    height: '100%'
  }
}));

export const BlogImg = styled(Image)(() => ({
  width: '100%',
  height: '100%',
  objectfit: 'cover'
}));

export const BlogContent = styled(Box)(() => ({
  display: 'flex',
  gap: '1em',
  marginTop: '2.5em',
  "@media (max-width: 768px)": {
    flexDirection: 'column',
    gap: '4em'
  }
}));

export const BlogContentDescription = styled(Box)(() => ({
  flex: 1
}));

export const BlogShareTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1.21em',
  color: 'rgba(0, 0, 0, 0.87)',
  fontWeight: '500',
}));

export const BlogShare = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.2em',
  alignItems: 'center',
  "@media (max-width: 768px)": {
    display: ' none'
  }
}));

export const BlogTags = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '1em'
}));

export const BlogTag = styled(Typography)(() => ({
  background: '#EEEEEE',
  borderRadius: '1.1em',
  padding: '0.21em 0.42em',
  fontFamily: 'Roboto',
  fontSize: '0.9em',
  color: 'rgba(0, 0, 0, 0.87)',
  fontWeight: '500',
  cursor: 'pointer'
}));

export const BlogIcon = styled('img')(() => ({
  width: '2.28em',
  height: '2.28em',
  objectfit: 'cover'
}));

export const BlogRelatedPost = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: '1em',
}));

export const BlogRelatedTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  marginTop: '2em',
  fontSize: '1.2em',
  color: 'rgba(0, 0, 0, 0.87)',
  fontWeight: '500',
  textTransform: 'capitalize',
  marginBottom: '1.2em'
}));

export const BlogRelatedPostMain = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1em',
}));

export const BlogRelatedPostImage = styled('img')(() => ({
  width: '3.6em',
  height: '3.6em',
  objectfit: 'cover',
  borderRadius: '.5em'
}));

export const BlogRelatedPostTitle = styled(Link)(({theme}) => ({
  fontFamily: 'Inter',
  fontSize: '1.em',
  color: theme.palette.secondary.main,
  fontWeight: '500',
  textTransform: 'capitalize',
  "@media (max-width: 768px)": {
    maxWidth: '15em'
  }
}));

export const BlogSubscribe = styled(Box)(() => ({
  width: '20em',
  "@media (max-width: 768px)": {
    width: '100%'
  }
}));

export const BlogSmallSocialMedia = styled(Box)(() => ({
  display: 'none',
  "@media (max-width: 768px)": {
    display: ' flex',
    alignItems: 'center',
    gap: '1em'
  }
}));
